import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { CustomButton } from '../commonComponents';

type iProps = {
    isModal: boolean,
    toggleModal: () => void,
    confirmationText: string | React.ReactNode,
    handleConfirmation: () => void,
    popupMinHeight?: string,
    modalHeader?: string,
    primaryBtnText?: string,
    secondaryBtnText?: string,
    isLoading?: boolean
}

const ConfirmationModal: React.FC<iProps> = ({ isModal, toggleModal, confirmationText, handleConfirmation, popupMinHeight, modalHeader,
    primaryBtnText, secondaryBtnText, isLoading
}) => {

    return (
        <Modal 
            isOpen={isModal} 
            toggle={toggleModal} 
            backdrop={true} 
            centered={true}
            className={`custom-modal-md modal-dialog-bottom modal-dialog-bottom-style`}
            modalClassName={`modal-slide-down`}
        >
            <ModalHeader>{modalHeader}</ModalHeader>
            <ModalBody style={{minHeight: popupMinHeight}}>
                {confirmationText}
            </ModalBody>
            <ModalFooter className='d-block'>
                <div className='d-flex w-100 mx-n-8'>
                    <div className='w-50 pd-x-8'><CustomButton text={secondaryBtnText} color='outline-primary' onClick={toggleModal} /></div>
                    <div className='w-50 pd-x-8'><CustomButton text={primaryBtnText} color='primary' onClick={handleConfirmation} isLoading={isLoading}/></div>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default ConfirmationModal;